'use client';

import { useEffect } from 'react';
import Script from 'next/script';

export function TopMailRu() {
  useEffect(() => {
    // Инициализация счетчика после загрузки скрипта
    if (typeof window !== 'undefined') {
      window._tmr = window._tmr || [];
      window._tmr.push({
        id: '3746386',
        type: 'pageView',
        start: new Date().getTime(),
      });
    }
  }, []);

  return (
    <>
      <Script
        id="top-mail-ru"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            var _tmr = window._tmr || (window._tmr = []);
            _tmr.push({id: "3746386", type: "pageView", start: (new Date()).getTime()});
            (function (d, w, id) {
              if (d.getElementById(id)) return;
              var ts = d.createElement("script");
              ts.type = "text/javascript";
              ts.async = true;
              ts.id = id;
              ts.src = "https://top-fwz1.mail.ru/js/code.js";
              var f = function () {
                var s = d.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(ts, s);
              };
              if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
              } else {
                f();
              }
            })(document, window, "tmr-code");
          `,
        }}
      />
      <noscript>
        <div>
          <img
            src="https://top-fwz1.mail.ru/counter?id=3746386;js=na"
            style={{ position: 'absolute', left: '-9999px' }}
            alt="Top.Mail.Ru"
          />
        </div>
      </noscript>
    </>
  );
}

// Добавляем типы для TypeScript
declare global {
  interface Window {
    _tmr: any[];
  }
}
